import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class BodyClassService {
  
  constructor(@Inject(DOCUMENT) private document: Document) {}

  public updateBodyClass(stateName: string): void {
    const body = this.document.querySelector('body');
    if (!body) return;

    // Remove any old state-* classes
    const classList = Array.from(body.classList);
    classList.forEach(className => {
      if (className.startsWith('state-')) {
        body.classList.remove(className);
      }
    });

    // Add new class from state name
    const normalizedStateName = stateName.replace(/\./g, '-'); // replace dots with dashes
    body.classList.add('state-' + normalizedStateName);
  }

  public removeAllStateClasses(): void {
    const body = this.document.querySelector('body');
    if (!body) return;

    const classList = Array.from(body.classList);
    classList.forEach(className => {
      if (className.startsWith('state-')) {
        body.classList.remove(className);
      }
    });
  }
}
